export const tokenKey = "asnoetuhaosenuthaoensuhaonesuhaonsetuhnjkm;qjvzkm";

export const OFFERS_CATEGORY_ID = 1;

export const MAIN_GREEN = "#05A794";

export const CATEGORIES = [
  { id: 33, name: "Fruits & légumes", color: "#05A794" },
  { id: 24, name: "Snacking", color: "#F6C500" },
  { id: 25, name: "Boissons chaudes", color: "#FF5500" },
  { id: 23, name: "Boissons fraîches", color: "#5DB1E1" },
  { id: 34, name: "Événements", color: "#3D57C9" },
  { id: 26, name: "Fruits secs" },
  { id: 27, name: "Boissons Alcoolisées" },
  { id: 28, name: "Autres", color: "#D3305F" },
  { id: 30, name: "Produits frais" },
  { id: 32, name: "Produits artisanaux" },
];

export const ADMIN_CATEGORIES = [
    { id: 3, name: "Délicartes mensuelles" },
    { id: 2, name: "Autour du corner" },
    { id: OFFERS_CATEGORY_ID, name: "Offres" },
];

export const CTA_MESSAGE_RETURN =
  "Un mail a été envoyé à notre team care, elle vous contacte au plus vite !";

export const HARDCODED_LINKS_OFFERS = [
    {name: 'La sélection du moment', url: 'https://selection-delicorner.squarespace.com/'},
    {name: 'L\'offre événementielle', url: 'https://selection-delicorner.squarespace.com/offre-event-delicorner'},
];
